import { useContext } from '../../context.jsx';
import { RunRxButton } from '../../../run-rx/RunRxButton.jsx';

export function LpkRunButton() {
  const { tab } = useContext();

  return tab === 'instances' ? null : (
    <RunRxButton module="lpk">Create LPK Rx</RunRxButton>
  );
}
